(() => {
  const ENDPOINT = 'https://zsvvdrtwucdzmoroomne.supabase.co/rest/v1/rpc/submit_creative_intake';
  const PUBLIC_KEY = 'sb_publishable_3hWZ8Nxx0bmzwG5-WJkisQ_dPt8wBtm';
  const root = document.querySelector('[data-f2f-intake]');
  if (!root) return;
  const form = root.querySelector('[data-intake-form]');
  const steps = [...root.querySelectorAll('[data-step]')];
  const branches = [...root.querySelectorAll('[data-branch]')];
  const back = root.querySelector('[data-back]');
  const next = root.querySelector('[data-next]');
  const submit = root.querySelector('[data-submit]');
  const progressLabel = root.querySelector('[data-progress-label]');
  const progressBar = root.querySelector('[data-progress-bar]');
  const status = root.querySelector('[data-submit-status]');
  const success = root.querySelector('[data-success]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = 1;

  const scrollBehavior = () => reduceMotion.matches ? 'auto' : 'smooth';
  const get = (name) => (new FormData(form).get(name) || '').toString().trim();
  const setError = (name, message='') => {
    const el = root.querySelector(`[data-error-for="${name}"]`);
    if (el) el.textContent = message;
  };
  const focusInvalid = (name) => {
    const field = form.elements.namedItem(name);
    if (!field) return;
    const target = field instanceof RadioNodeList ? root.querySelector(`[name="${name}"]`) : field;
    if (target && typeof target.focus === 'function') target.focus();
  };
  const selectedService = () => get('service_interest');
  const showBranch = () => {
    const service = selectedService();
    branches.forEach((branch) => { branch.hidden = branch.dataset.branch !== service; });
  };
  const focusStep = () => {
    const heading = root.querySelector(`[data-step="${current}"] h2`);
    if (!heading) return;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
    heading.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
  };
  const render = (focus=true) => {
    steps.forEach((step) => {
      const active = Number(step.dataset.step) === current;
      step.hidden = !active;
      step.classList.toggle('is-active', active);
      step.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    back.hidden = current === 1;
    next.hidden = current === 4;
    submit.hidden = current !== 4;
    progressLabel.textContent = `Step ${current} of 4`;
    progressBar.style.width = `${current * 25}%`;
    progressBar.setAttribute('aria-valuenow', String(current));
    if (current === 2) showBranch();
    if (focus) focusStep();
  };
  const validStep = () => {
    if (current === 1) {
      const ok = !!selectedService();
      setError('service_interest', ok ? '' : 'Choose the closest starting point.');
      if (!ok) focusInvalid('service_interest');
      return ok;
    }
    if (current === 2) {
      const value = get('project_summary');
      const ok = value.length >= 10;
      setError('project_summary', ok ? '' : 'Tell us a little more about what you’re trying to create.');
      if (!ok) focusInvalid('project_summary');
      return ok;
    }
    if (current === 4) {
      const name = get('customer_name');
      const email = get('email');
      const nameOk = name.length > 0;
      const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      setError('customer_name', nameOk ? '' : 'Your name is required.');
      setError('email', emailOk ? '' : 'Enter a valid email address.');
      if (!nameOk) focusInvalid('customer_name');
      else if (!emailOk) focusInvalid('email');
      return nameOk && emailOk;
    }
    return true;
  };
  const branchNotes = () => {
    const fd = new FormData(form);
    const lines = [];
    for (const [key, value] of fd.entries()) {
      if (key.startsWith('branch_') && String(value).trim()) {
        lines.push(`${key.replace('branch_','').replaceAll('_',' ')}: ${String(value).trim()}`);
      }
    }
    return lines.length ? `Service-specific details:\n${lines.join('\n')}` : '';
  };
  const payload = () => {
    const branch = branchNotes();
    const notes = get('other_notes');
    return {
      _customer_name:get('customer_name'), _email:get('email'), _project_summary:get('project_summary'), _service_interests:[selectedService()],
      _company_organization:get('company_organization') || null, _phone:get('phone') || null, _preferred_contact:get('preferred_contact') || null,
      _customer_type:null, _project_title:null, _goals_objectives:get('goals_objectives') || null, _target_audience:get('target_audience') || null,
      _needed_deliverables:get('needed_deliverables') || null, _existing_brand_assets:get('existing_brand_assets') || null,
      _brand_asset_links:get('brand_asset_links') || null, _inspiration_links:get('inspiration_links') || null,
      _desired_deadline:get('desired_deadline') || null, _deadline_flexibility:get('deadline_flexibility') || null,
      _budget_range:get('budget_range') || null, _how_heard_about_us:get('how_heard_about_us') || null,
      _other_notes:[branch,notes].filter(Boolean).join('\n\n') || null, _marketing_consent:new FormData(form).has('marketing_consent'),
      _company_website:get('company_website') || null
    };
  };

  root.addEventListener('change', (event) => {
    if (event.target && event.target.name === 'service_interest') {
      setError('service_interest');
      showBranch();
    }
  });
  next.addEventListener('click', () => {
    if (!validStep()) return;
    current = Math.min(4,current+1);
    render();
  });
  back.addEventListener('click', () => {
    current = Math.max(1,current-1);
    render();
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!validStep()) return;
    status.textContent = '';
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');
    submit.textContent = 'Sending…';
    try {
      const res = await fetch(ENDPOINT,{method:'POST',headers:{'apikey':PUBLIC_KEY,'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload())});
      const data = await res.json().catch(() => null);
      if (!res.ok) throw new Error((data && (data.message || data.error_description)) || 'Submission failed');
      const row = Array.isArray(data) ? data[0] : data;
      if (!row || !row.job_number) throw new Error('No project number returned');
      root.querySelector('[data-job-number]').textContent = row.job_number;
      form.hidden = true;
      root.querySelector('.f2f-intake__progress').hidden = true;
      success.hidden = false;
      success.focus({ preventScroll: true });
      success.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    } catch (err) {
      console.error('F2F intake submission error', err);
      status.textContent = 'We couldn’t send your project just now. Please try again. If the problem continues, call 315-313-HOLY.';
      status.focus?.();
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
      submit.textContent = 'Send Project Request';
    }
  });
  render(false);
})();